import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Loader2, RefreshCw } from 'lucide-react'

import { EID } from '@/lib/element-ids.registry'
import { useReauditListingAudit } from '@/hooks/useListingBuilder'

interface ReauditButtonProps {
  jobId: string
}

/** Trigger a fresh audit version for an existing listing and navigate to the new job. */
export function ReauditButton({ jobId }: ReauditButtonProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const reaudit = useReauditListingAudit()

  const handleClick = () => {
    if (!window.confirm(t('listingBuilder.report.reauditConfirm'))) return
    reaudit.mutate(jobId, {
      onSuccess: (r) => navigate(`/v2/tools/listing-builder/${r.job_id}`),
    })
  }

  return (
    <button
      id={EID['listing-builder-reaudit-btn']}
      type="button"
      onClick={handleClick}
      disabled={reaudit.isPending}
      className="flex items-center gap-1.5 text-sm text-neutral-600 transition-colors hover:text-neutral-900 disabled:opacity-50 dark:text-neutral-400 dark:hover:text-neutral-100"
    >
      {reaudit.isPending ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <RefreshCw className="h-4 w-4" />
      )}
      <span>{t('listingBuilder.report.reaudit')}</span>
    </button>
  )
}
